import firebase from "datastore/database";
import store from "datastore/store";

export default async function fetchRaffles() {
  store.dispatch({ type: "ADD_RAFFLES_LOADING" });
  const rafflesCollection = await firebase
    .firestore()
    .collection("raffles")
    .get();
  const raffles = Object.create(null);
  rafflesCollection.docs.forEach(
    (doc) => (raffles[doc.id] = { uid: doc.id, ...doc.data() })
  );
  const parsedRaffles = await Promise.all(
    Object.entries(raffles).map(async (entry) => {
      const [uid, item] = entry;
      const visits = [];
      const visitsCollection = await firebase
        .firestore()
        .collection("visits/business/" + uid)
        .get();
      visitsCollection.forEach((doc) =>
        visits.push({ uid: doc.id, ...doc.data() })
      );

      const raffleItems = Object.entries(item.raffles).map((entry) => {
        const [uid, raffle] = entry;
        const prize = item.prizes[raffle.prize];
        const participants = visits.filter(
          (visit) =>
            raffle.start.toDate() < visit.processedTime.toDate() &&
            visit.processedTime.toDate() < raffle.end.toDate()
        );
        return { uid, ...raffle, prize, participants };
      });
      return { uid, raffles: raffleItems };
    })
  );
  store.dispatch({ type: "ADD_RAFFLES_SUCCESS", raffles: parsedRaffles });
}
